module.exports = __webpack_public_path__ + "static/media/Inter-Medium.93dab51d.woff2";